import gsap from "gsap";

export default {
  init() {
    let isOpen = false;
    const trigger = document.querySelector(".topbar__burger");
    const bar1 = trigger.querySelector("div:nth-child(1)");
    const bar2 = trigger.querySelector("div:nth-child(2)");
    const bar3 = trigger.querySelector("div:nth-child(3)");
    const nav = document.querySelector(".topbar__nav");

    trigger.addEventListener("click", () => {
      if (isOpen) {
        isOpen = false;

        gsap.to(bar1, {
          duration: 0.2,
          rotation: 0,
          y: 0,
          backgroundColor: "black",
          ease: "power2.out",
        });
        gsap.to(bar2, {
          duration: 0.2,
          opacity: 1,
          ease: "power2.out",
        });
        gsap.to(bar3, {
          duration: 0.2,
          rotation: 0,
          y: 0,
          backgroundColor: "black",
          ease: "power2.out",
        });

        gsap.to(nav, {
          duration: 0.2,
          opacity: 0,
          scale: 0.95,
          ease: "power2.out",
          onComplete: () => {
            nav.style.pointerEvents = "none";
            document.body.style.overflow = "auto";
          },
        });
      } else {
        isOpen = true;

        gsap.to(bar1, {
          duration: 0.2,
          rotation: 45,
          y: 6,
          backgroundColor: "#fff",
          ease: "power2.out",
        });
        gsap.to(bar2, {
          duration: 0.2,
          opacity: 0,
          ease: "power2.out",
        });
        gsap.to(bar3, {
          duration: 0.2,
          rotation: -45,
          y: -6,
          backgroundColor: "#fff",
          ease: "power2.out",
        });

        gsap.fromTo(
          nav,
          { scale: 0.9 },
          {
            duration: 0.2,
            opacity: 1,
            scale: 1,
            ease: "power2.out",
            onStart: () => {
              nav.style.pointerEvents = "auto";
              document.body.style.overflow = "hidden";
            },
          }
        );
      }
    });
  },
};
